<template>
	<div v-if="!isMobile" class="container">
		<div class="body flex-grow-1 col-12 col-md-5 px-0">
			<div>
				<div class="modal-body w-full py-0 d-flex flex-column align-items-center">
					<h3 class="modal-heading">We hope to see you again soon!</h3>
					<div class="modal-subheading">
						Please reach out to <a href="mailto:friends@stanwith.me">friends@stanwith.me</a> if you have any questions
					</div>
				</div>
				<div class="d-flex flex-column  align-items-center  gap v-gap pt-1">
					<AppButton name="next-step-cancel-subscription-confirmation" size="large" @click="nextStep">Thanks!</AppButton>
				</div>
			</div>
		</div>

		<div class="body flex-grow-1 col-12 col-md-5 px-0">
			<div v-if="!imageReady" class="image-placeholder" />
			<img v-show="imageReady" src="/images/cancellation/bye.svg" @load="imageReady = true" />
		</div>
	</div>
	<div v-else class="container mobile-container d-flex justify-content-center align-items-center">
		<div class="body flex-column flex-gap-50 h-100">
			<div class="body flex-shrink-1 overflow-hidden px-0">
				<div v-if="!imageReady" class="image-placeholder" />
				<img v-show="imageReady" src="/images/cancellation/bye.svg" @load="imageReady = true" />
			</div>
			<div class="body px-0">
				<div>
					<div class="modal-body w-full py-0 d-flex flex-column align-items-center">
						<h3 class="modal-heading">We hope to see you again soon!</h3>
						<div class="modal-subheading">
							Please reach out to <a href="mailto:friends@stanwith.me">friends@stanwith.me</a> if you have any questions
						</div>
					</div>
					<div class="d-flex flex-column  align-items-center  gap v-gap pt-1">
						<AppButton name="next-step-cancel-subscription-confirmation" size="large" @click="nextStep">Thanks!</AppButton>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { mapGetters } from 'vuex'

	export default {
		components: {},
		props: {},
		data() {
			return {
				stepName: 'cancel subscription confirmation',
				imageReady: false,
			}
		},
		mounted() {
			this.start()
		},
		computed: {
			...mapGetters('Auth', ['user']),
			isMobile() {
				return this.$commonHelper.isMobile()
			},
		},
		methods: {
			start() {
				this.$emit('start', {
					eventName: 'cancellation-subscription-cancelled-confirmation',
					props: { step_name: this.stepName },
				})
			},
			nextStep() {
				this.$emit('next-step')
			},
			reset() {
				this.imageReady = false
			},
		},
	}
</script>

<style lang="scss" scoped></style>
